import React, { useState, useEffect } from "react";

import axios from "axios";
import { server } from "../../../utills/utils";
import { connect } from "react-redux";

import Product from "./Product";
import AddProduct from "./AddProduct";
import AddModal from "../../Modals/LargeModal";
import CancelModal from "../../Modals/CancelModal";
import Spinner from "../../Modals/SpinnerModal";
import AddedModal from "../../Modals/NotifyModal";
import Modal from "../../Modals/ProductModal";
import AddProductOwn from "./AddProductOwn";

import EmptyImg from "../../../assets/products.png";

import CrossImg from "../../../assets/cancel.png";

import styled from "styled-components";

const Container = styled.div`
  width: 90%;
  height: 90%;
  background: #f5f5f5;
  padding: 3.5% 5%;
  border-radius: 5px;
`;
const Header = styled.div`
  width: 100%;
  height: 15%;
`;
const HeaderLeft = styled.div`
  width: 30%;
  height: 100%;
  float: left;
`;
const Title = styled.h2`
  font-size: 1.2em;
  margin: 0;
  padding: 0;
  font-weight: 500;
`;
const Amount = styled.p`
  font-size: 1em;
  margin: 0;
  padding: 5px 0;
`;
const HeaderRight = styled.div`
  width: 65%;
  height: auto;
  float: right;
  padding-top: 12px;
  margin-right: 1px;
`;
const AddButton = styled.button`
  height: 45px;
  border: 1px solid #ccc;
  background: none;
  outline: none;
  cursor: pointer;
  font-weight: 600;
  border-radius: 5px;
  font: inherit;
  float: right;
  padding: 0 5px;
  margin: 0 5px;
`;
const SearchContainer = styled.div`
  width: 60%;
  height: 45px;
  float: right;
  border: 1px solid #ccc;
  border-radius: 5px;
`;
const ProductsContainer = styled.div`
  width: 103%;
  height: 86%;
  margin-top: 10px;
  overflow-y: scroll;
  display: flex;
  flex-flow: wrap;
  flex-direction: row;
  align-content: flex-start;
`;
const SearchInput = styled.input`
  width: 75%;
  padding: 10px 4%;
  border: none;
  outline: none;
  background: none;
  font: inherit;
`;
const ProductAddHeader = styled.div`
  width: 100%;
  height: 9%;
  border-bottom: 2px solid #ccc;
`;
const AvailabelProducts = styled.div`
  width: 100%;
  height: 90%;
  margin-top: 10px;
  overflow-y: scroll;
  display: flex;
  flex-flow: wrap;
`;
const CloseModal = styled.button`
  float: right;
  border: none;
  background: none;
  margin: 10px;
  cursor: pointer;
`;
const ButtonImg = styled.img`
  width: 25px;
  height: 25px;
`;
const AddTitle = styled.h3`
  margin: 0;
  padding: 7px 5px;
  font-weight: 500;
  font-size: 1.4em;
`;

const Button1 = styled.button`
  width: 48.5%;
  padding: 10px;
  margin: 5px 5% 0 0;
  font-size: 1em;
  background: #ff5d5d;
  border: none;
  color: wproductViewModalte;
  border-radius: 5px;
  cursor: pointer;
  color: white;
`;
const Button2 = styled.button`
  width: 45%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
`;

const CancelTitle = styled.p``;

function Products(props) {
  const [products, setProducts] = useState([]);
  const [complete, setComplete] = useState(false);
  const [addToProducts, setAddToProducts] = useState([]);
  const [availLoad, setAvailLoad] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [cancelId, setCancelId] = useState(null);
  const [spinner, setSpinner] = useState(false);
  const [added, setAdded] = useState(false);
  const [addOwn, setAddOwn] = useState(false);
  const [category, setCategory] = useState(null);

  const addOwnHandler = () => {
    if (!addOwn) {
      getGetegory();
      setTimeout(() => {
        setAddOwn(!addOwn);
      }, 500);
    } else {
      setAddOwn(!addOwn);
    }
  };

  const fetchProducts = async () => {
    try {
      const products = await axios.post(server, {
        query: `
                          query{
                              shopProducts(shopId:"${localStorage.shopId}", owner:"true"){
                                _id
                                name
                                price
                                product{
                                _id
                                name
                                brandName
                                brandId
                                name
                                price
                                measurment
                                images
                                
                                }
                              }
                          }
                        `,
      });
      setProducts(products.data.data.shopProducts);
      setComplete(true);
    } catch (error) {
      throw error;
    }
  };

  const fetchProductsToAdd = async () => {
    try {
      setAddModal(true);
      const products = await axios.post(server, {
        query: `
                          query{
                             availablePorductsToAdd(shopId:"${localStorage.shopId}"){
                                _id
                                name
                                brandName
                                brandId
                                name
                                price
                                subCategoryId
                                subCategoryName
                                measurment
                                images
                              }
                          }
                        `,
      });
      setAddToProducts(products.data.data.availablePorductsToAdd);
      setAvailLoad(true);
    } catch (error) {
      throw error;
    }
  };
  const AddModalClose = () => {
    setAddModal(false);
  };
  const addProductToShop = async (input) => {
    try {
      console.log("Input", input);
      if (input.price) {
        console.log("Input", input);

        const newProducts = addToProducts.filter((product) => {
          return product._id !== input.productId;
        });
        setAddToProducts(newProducts);
        setAdded(true);
        setTimeout(() => setAdded(false), 1000);
        const addProduct = await axios.post(server, {
          query: `
                  mutation{
                    addShopProduct(input:
                        {
                            productId:"${input.productId}",
                            price:${input.price},
                            shopId:"${localStorage.shopId}",
                            name:"${input.name}",
                            categoryId:"${input.categoryId}",
                            categoryName:"${input.categoryName}",
                            brandId:"${input.brandId}",
                            brandName:"${input.brandName}"
                        }
                        ){
                            _id
                            name
                            price
                            product{
                                _id
                                name
                                brandName
                                brandId
                                name
                                price
                                measurment
                                images
                            
                        }
                    }
                  }
                `,
        });
        console.log(addProduct);
        setProducts(addProduct.data.data.addShopProduct);
      }
    } catch (error) {
      throw error;
    }
  };
  const cancelRequest = async (productId) => {
    try {
      setCancel(false);
      setSpinner(true);

      await axios.post(server, {
        query: `
                    mutation{
                      deleteShopProduct(productId:"${productId}"){
                          _id
                          name
                          price
                          product{
                              _id
                              name
                              brandName
                              brandId
                              name
                              price
                              measurment
                              images
                          
                      }
                        }
                    }
                  `,
      });
      const updatedProducts = products.filter((product) => {
        return product._id !== cancelId;
      });
      setProducts(updatedProducts);
      setSpinner(false);
      setCancelId(null);
    } catch (error) {
      throw error;
    }
  };

  const cancelModaHandler = (id) => {
    setCancel(true);
    setCancelId(id);
  };
  const cancelCloseHandler = () => {
    setCancel(false);
    setCancelId(null);
  };

  const addProductOwnHandler = (product) => {
    try {
      const newProducts = [];
      newProducts.push(product);
      setProducts([...newProducts, ...products]);
      setAddOwn(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getGetegory = async () => {
    try {
      if (props.merchant) {
        await axios
          .post(server, {
            query: `
           query{
            getCategory(catId:"${props.merchant.categoryId}"){
              _id
              name
              subCategories{
                _id
                name
              }

            }
           }
         `,
          })
          .then((res) => {
            console.log("Category", res);
            setCategory(res.data.data.getCategory);
          });
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);
  return (
    <Container>
      <Spinner show={spinner} />
      <Modal show={addOwn} closeModal={addOwnHandler}>
        <AddProductOwn
          category={category}
          addProductOwnHandler={addProductOwnHandler}
          closeModal={addOwnHandler}
        ></AddProductOwn>
      </Modal>
      <AddedModal show={added}>
        <img
          src="https://www.clipartmax.com/png/middle/317-3179395_best-quality-complete-icon.png"
          alt="icon"
        />
        <p>Product added to shop successfully!</p>
      </AddedModal>
      <CancelModal show={cancel} closeModal={cancelCloseHandler}>
        <CancelTitle>
          Are you sure want to delete product permanently ?
        </CancelTitle>
        <Button1
          onClick={() => {
            cancelRequest(cancelId);
          }}
        >
          Yes
        </Button1>
        <Button2 onClick={cancelCloseHandler}>No</Button2>
      </CancelModal>
      <AddModal show={addModal} closeModal={AddModalClose}>
        <ProductAddHeader>
          <div style={{ width: "70%", height: "100%", float: "left" }}>
            <AddTitle>Add Product</AddTitle>
          </div>
          <CloseModal onClick={AddModalClose}>
            <ButtonImg src={CrossImg} alt="button" />
          </CloseModal>
        </ProductAddHeader>
        <AvailabelProducts>
          {availLoad ? (
            addToProducts.map((product) => {
              return (
                <AddProduct
                  addHandler={addProductToShop}
                  key={product._id}
                  product={product}
                />
              );
            })
          ) : (
            <p>Loading...</p>
          )}
        </AvailabelProducts>
      </AddModal>
      <Header>
        <HeaderLeft>
          <Title>Products</Title>
          <Amount>{products.length} types of product available</Amount>
        </HeaderLeft>
        <HeaderRight>
          {/* <AddButton
          // onClick={fetchProductsToAdd}
          >
            Add or you +
          </AddButton> */}
          {props.merchant.categoryId != "6129e467f8785a2974c9915a" ? (
            <AddButton onClick={fetchProductsToAdd}>
              Add product from mamatovai +{" "}
            </AddButton>
          ) : null}

          <AddButton onClick={addOwnHandler}>
            {props.merchant.categoryId != "6129e467f8785a2974c9915a"
              ? "Add you own"
              : "Add service"}{" "}
            +{" "}
          </AddButton>
          {/* <SearchContainer>
            <SearchInput type="text" placeholder="Search a product" />
          </SearchContainer> */}
        </HeaderRight>
      </Header>
      <ProductsContainer>
        {complete ? (
          products.length > 0 ? (
            products.map((product) => {
              return (
                <Product
                  cancelModaHandler={cancelModaHandler}
                  key={product._id}
                  product={product}
                />
              );
            })
          ) : (
            <img
              style={{ width: "100%", textAlign: "center", height: "80%" }}
              src={EmptyImg}
              alt="image"
            />
          )
        ) : (
          <p>Loading...</p>
        )}
      </ProductsContainer>
    </Container>
  );
}

// export default Products;
const mapStateToProps = (state) => {
  return {
    merchant: state.utils.merchant,
  };
};

// const mapDispatchToProps = (dispatch) => {
//   return {
//     setMerchant: (data) => {
//       dispatch({
//         type: actionTypes.SET_MERCHANT,
//         data,
//       });
//     },
//   };
// };

export default connect(mapStateToProps)(Products);
